export const EmojiData = {
  Grinning: { value: String.fromCodePoint(0x1f600) },
  Beaming: { value: String.fromCodePoint(0x1f601) },
  TearsOfJoy: { value: String.fromCodePoint(0x1f602) },
  RollingOnFloor: { value: String.fromCodePoint(0x1f923) },
  GrinningBigEyes: { value: String.fromCodePoint(0x1f603) },
  GrinningSmilingEyes: { value: String.fromCodePoint(0x1f604) },
  GrinningWithSweat: { value: String.fromCodePoint(0x1f605) },
  GrinningSquinting: { value: String.fromCodePoint(0x1f606) },
  Winking: { value: String.fromCodePoint(0x1f609) },
  SmilingWithSmilingEyes: { value: String.fromCodePoint(0x1f60a) },
  SavoringFood: { value: String.fromCodePoint(0x1f60b) },
  Sunglasses: { value: String.fromCodePoint(0x1f60e) },
  HeartEyes: { value: String.fromCodePoint(0x1f60d) },
  BlowingKiss: { value: String.fromCodePoint(0x1f618) },
  Kissing: { value: String.fromCodePoint(0x1f617) },
  KissingSmilingEyes: { value: String.fromCodePoint(0x1f619) },
  KissingClosedEyes: { value: String.fromCodePoint(0x1f61a) },
  Smiling: { value: String.fromCodePoint(0x263a) },
  SlightlySmiling: { value: String.fromCodePoint(0x1f642) },
  Hugging: { value: String.fromCodePoint(0x1f917) },
  StarStruck: { value: String.fromCodePoint(0x1f929) },
  Thinking: { value: String.fromCodePoint(0x1f914) },
  RaisedEyebrow: { value: String.fromCodePoint(0x1f928) },
  NeutralFace: { value: String.fromCodePoint(0x1f610) },
  Expressionless: { value: String.fromCodePoint(0x1f611) },
  WithoutMouth: { value: String.fromCodePoint(0x1f636) },
  RollingEyes: { value: String.fromCodePoint(0x1f644) },
  Smirking: { value: String.fromCodePoint(0x1f60f) },
  Persevering: { value: String.fromCodePoint(0x1f623) },
  SadRelieved: { value: String.fromCodePoint(0x1f625) },
  OpenMouth: { value: String.fromCodePoint(0x1f62e) },
  ZippedMouth: { value: String.fromCodePoint(0x1f910) },
  Hushed: { value: String.fromCodePoint(0x1f62f) },
  Sleepy: { value: String.fromCodePoint(0x1f62a) },
  Relieved: { value: String.fromCodePoint(0x1f60c) },
  TongueOut: { value: String.fromCodePoint(0x1f61b) },
  TongueOutWinking: { value: String.fromCodePoint(0x1f61c) },
  // START SILLY FACES
  CowboyHat: { value: String.fromCodePoint(0x1f920) },
  Clown: { value: String.fromCodePoint(0x1f921) },
  Lying: { value: String.fromCodePoint(0x1f925) },
  Shushing: { value: String.fromCodePoint(0x1f92b) },
  HandOverMouth: { value: String.fromCodePoint(0x1f92d) },
  FaceWithMonocle: { value: String.fromCodePoint(0x1f9d0) },
  Nerd: { value: String.fromCodePoint(0x1f913) },
  SmilingHorns: { value: String.fromCodePoint(0x1f608) },
  AngryHorns: { value: String.fromCodePoint(0x1f47f) },
  Ogre: { value: String.fromCodePoint(0x1f479) },
  Goblin: { value: String.fromCodePoint(0x1f47a) },
  Skull: { value: String.fromCodePoint(0x1f480) },
  Ghost: { value: String.fromCodePoint(0x1f47b) },
  Alien: { value: String.fromCodePoint(0x1f47d) },
  AlienMonster: { value: String.fromCodePoint(0x1f47e) },
  Robot: { value: String.fromCodePoint(0x1f916) },
  Poo: { value: String.fromCodePoint(0x1f4a9) },
  // END FACES
  Baby: { value: String.fromCodePoint(0x1f476), canAddTone: true },
  Boy: { value: String.fromCodePoint(0x1f466), canAddTone: true },
  Girl: { value: String.fromCodePoint(0x1f467), canAddTone: true },
  Adult: { value: String.fromCodePoint(0x1f9d1), canAddTone: true },
  Man: { value: String.fromCodePoint(0x1f468), canAddTone: true, canAddProfession: true },
  Woman: { value: String.fromCodePoint(0x1f469), canAddTone: true, canAddProfession: true },
  OldMan: { value: String.fromCodePoint(0x1f474), canAddTone: true },
  OldWoman: { value: String.fromCodePoint(0x1f475), canAddTone: true },
  GestureOK: { value: String.fromCodePoint(0x1f646), canAddTone: true, canAddGender: true },
  GestureNo: { value: String.fromCodePoint(0x1f645), canAddTone: true, canAddGender: true },
  RaisingHand: { value: String.fromCodePoint(0x1f64b), canAddTone: true, canAddGender: true },
  Bowing: { value: String.fromCodePoint(0x1f647), canAddTone: true, canAddGender: true },
  Faceplam: { value: String.fromCodePoint(0x1f926), canAddTone: true, canAddGender: true },
  Policeman: { value: String.fromCodePoint(0x1f46e), canAddTone: true, canAddGender: true },
  Detective: { value: String.fromCodePoint(0x1f575), canAddTone: true, canAddGender: true },
  Guard: { value: String.fromCodePoint(0x1f482), canAddTone: true, canAddGender: true },
  ConstructionWorker: { value: String.fromCodePoint(0x1f477), canAddTone: true, canAddGender: true },
  Mage: { value: String.fromCodePoint(0x1f9d9), canAddTone: true, canAddGender: true },
  Fairy: { value: String.fromCodePoint(0x1f9da), canAddTone: true, canAddGender: true },
  Vampire: { value: String.fromCodePoint(0x1f9db), canAddTone: true, canAddGender: true },
  Mermaid: { value: String.fromCodePoint(0x1f9dc), canAddTone: true, canAddGender: true },
  Elf: { value: String.fromCodePoint(0x1f9dd), canAddTone: true, canAddGender: true },
  Genie: { value: String.fromCodePoint(0x1f9de), canAddGender: true },
  Zombie: { value: String.fromCodePoint(0x1f9df), canAddGender: true }, // limited support for skin tone
  Shrug: { value: String.fromCodePoint(0x1f937), canAddTone: true, canAddGender: true },
  // Hand Symbols
  FlexedBiceps: { value: String.fromCodePoint(0x1f4aa), canAddTone: true },
  // For Professions
  StaffAsch: { value: String.fromCodePoint(0x2695) },
  School: { value: String.fromCodePoint(0x1f3eb) },
  GradCap: { value: String.fromCodePoint(0x1f393) },
  LawScale: { value: String.fromCodePoint(0x2696) },
  Wheat: { value: String.fromCodePoint(0x1f33e) },
  FryingPan: { value: String.fromCodePoint(0x1f373) },
  Wrench: { value: String.fromCodePoint(0x1f527) },
  Factory: { value: String.fromCodePoint(0x1f3ed) },
  Briefcase: { value: String.fromCodePoint(0x1f4bc) },
  Microscope: { value: String.fromCodePoint(0x1f52c) },
  Computer: { value: String.fromCodePoint(0x1f4bb) },
  Microphone: { value: String.fromCodePoint(0x1f3a4) },
  ArtistPalette: { value: String.fromCodePoint(0x1f3a8) },
  Airplane: { value: String.fromCodePoint(0x2708) },
  Rocket: { value: String.fromCodePoint(0x1f680) },
  Firetruck: { value: String.fromCodePoint(0x1f692) },
  // Random
  Bat: { value: String.fromCodePoint(0x1f987) },
  JackOLantern: { value: String.fromCodePoint(0x1f383) },
  Spider: { value: String.fromCodePoint(0x1f577) },
  SpiderWeb: { value: String.fromCodePoint(0x1f578) },
  SeeNoEvil: { value: String.fromCodePoint(0x1f648) }
};



// WEBPACK FOOTER //
// ./src/common/components/emoji/emoji.data.ts